<template functional>
  <div class="footer-address">
    <h3 class="footer-address__heading">
      Kontakt
    </h3>

    <address>
      <el-row :gutter="32">
        <el-col :sm="12">
          Claussen-Simon-Stiftung<br>
          Große Elbstraße 145f<br>
          22767 Hamburg
        </el-col>

        <el-col :sm="12">
          <a
            class="footer-address__link"
            href="tel:+494038037150"
          >
            Tel.: +49 (0) 40 38 03 71 5-0
          </a><br>
          <a
            class="footer-address__link"
            href="mailto:info@claussen-simon-stiftung.de"
          >
            info@claussen-simon-stiftung.de
          </a>
        </el-col>
      </el-row>
    </address>
  </div>
</template>

<script>
export default {
  name: 'AFooterAddress'
}
</script>

<style lang="scss" scoped>
.footer-address {
  margin-bottom: 1em;
}

.footer-address__heading {
  margin: 0;

  font-size: 1em;
  color: $--color-primary;
}

.footer-address__link {
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
}
</style>
